module.exports = __webpack_public_path__ + "img/icon3.6f3c7ef6.png";